import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_axios_9d6fa4e8 from 'nuxt_plugin_axios_9d6fa4e8' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_serverstorage_461f9ce5 from 'nuxt_plugin_serverstorage_461f9ce5' // Source: ../src/plugins/server-storage (mode: 'all')
import nuxt_plugin_elementui_d905880e from 'nuxt_plugin_elementui_d905880e' // Source: ../src/plugins/element-ui (mode: 'all')
import nuxt_plugin_errorhandler_25db1b11 from 'nuxt_plugin_errorhandler_25db1b11' // Source: ../src/plugins/error-handler (mode: 'client')
import nuxt_plugin_globalinit_7f231a86 from 'nuxt_plugin_globalinit_7f231a86' // Source: ../src/plugins/global-init (mode: 'all')
import nuxt_plugin_routerpush_671c28aa from 'nuxt_plugin_routerpush_671c28aa' // Source: ../src/plugins/router-push (mode: 'all')
import nuxt_plugin_globalcomponents_54ec6fe8 from 'nuxt_plugin_globalcomponents_54ec6fe8' // Source: ../src/plugins/global-components (mode: 'all')
import nuxt_plugin_lazyload_0d09004e from 'nuxt_plugin_lazyload_0d09004e' // Source: ../src/plugins/lazyload (mode: 'client')
import nuxt_plugin_vueesign_b931fdb2 from 'nuxt_plugin_vueesign_b931fdb2' // Source: ../src/plugins/vue-esign (mode: 'client')
import nuxt_plugin_socialsharing_34386970 from 'nuxt_plugin_socialsharing_34386970' // Source: ../src/plugins/social-sharing (mode: 'client')
import nuxt_plugin_eventbus_bb49754e from 'nuxt_plugin_eventbus_bb49754e' // Source: ../src/plugins/event-bus (mode: 'all')
import nuxt_plugin_analytics_3ba45812 from 'nuxt_plugin_analytics_3ba45812' // Source: ../src/plugins/analytics (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"chaoangoods","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width,initial-scale=1.0"},{"name":"trustpilot-one-time-domain-verification-id","content":"00b018ad-6a50-4ca3-98f9-c810c35aa495"},{"name":"google-site-verification","content":"tBiFCueeqwcYS4Qh5bTc_juKjADsjE4uZyFVwOouwDk"},{"name":"google-site-verification","content":"lS6m95EId2VpibXAzQ-EpRJDHN-Z8NFxUKMPHpUepf8"},{"hid":"description","name":"description","content":"【chaoangoods Mall】 Genuine product guarantee, millions of items for you to choose from! Daily new arrivals, super value flash sales, direct discounts on big brands, and continuous discounts for reaching certain spending amounts. Support 7-day no-reason return and exchange, express delivery, and enjoy a convenient shopping experience."},{"http-equiv":"X-UA-Compatible","content":"IE=edge"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"noscript":[{"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-K84LST5X\"\nheight=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"\u003E\u003C\u002Fiframe\u003E","body":true,"hid":"noscript"}],"script":[{"hid":"inline-init","innerHTML":"\n           (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer','GTM-K84LST5X');\n        ","type":"text\u002Fjavascript"},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-8PVJ6LE9G7","async":true,"body":true},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-NX7BYZN57N","async":true,"body":true},{"hid":"inline-init","innerHTML":"\n           window.dataLayer = window.dataLayer || [];\n          function gtag(){dataLayer.push(arguments);}\n          gtag('js', new Date());\n\n          gtag('config', 'G-8PVJ6LE9G7');\n        ","type":"text\u002Fjavascript","body":true},{"hid":"inline-init","innerHTML":"\n           window.dataLayer = window.dataLayer || [];\n          function gtag(){dataLayer.push(arguments);}\n          gtag('js', new Date());\n\n          gtag('config', 'G-NX7BYZN57N');\n        ","type":"text\u002Fjavascript","body":true},{"hid":"inline-init","innerHTML":"\n          {\n  \"@context\": \"https:\u002F\u002Fschema.org\",\n  \"@graph\": [\n    {\n      \"@type\": \"Organization\",\n      \"@id\": \"https:\u002F\u002Fchaoangoods.com\u002F#organization\",\n      \"name\": \"chaoangoods\",\n      \"url\": \"https:\u002F\u002Fchaoangoods.com\u002F\",\n      \"description\": \"Product and manufacturer browsing, buyer registration, and quotation requests for daily-use goods and industrial supplies.\",\n      \"email\": \"chaoangoods@gmail.com\",\n      \"telephone\": \"+86-13714930005\",\n      \"address\": {\n        \"@type\": \"PostalAddress\",\n        \"streetAddress\": \"5th Floor, Fengxi Ceramic Building\",\n        \"addressLocality\": \"Chao'an, Chaozhou\",\n        \"addressRegion\": \"Guangdong\",\n        \"addressCountry\": \"CN\"\n      },\n      \"brand\": {\n        \"@id\": \"https:\u002F\u002Fchaoangoods.com\u002F#brand\"\n      },\n      \"contactPoint\": {\n        \"@type\": \"ContactPoint\",\n        \"telephone\": \"+86-13714930005\",\n        \"contactType\": \"customer service\",\n        \"email\": \"chaoangoods@gmail.com\",\n        \"availableLanguage\": [\"Chinese\", \"English\"]\n      }\n    },\n    {\n      \"@type\": \"Brand\",\n      \"@id\": \"https:\u002F\u002Fchaoangoods.com\u002F#brand\",\n      \"name\": \"chaoangoods\",\n      \"url\": \"https:\u002F\u002Fchaoangoods.com\u002F\"\n    },\n    {\n      \"@type\": \"FAQPage\",\n      \"@id\": \"https:\u002F\u002Fchaoangoods.com\u002F#faq\",\n      \"mainEntity\": [\n        {\n          \"@type\": \"Question\",\n          \"name\": \"What products are listed on Chaoangoods?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"The homepage names ceramics, bathroom and home products, stainless steel kitchenware, wedding dresses, toys, fashion accessories, 3C digital products, aquatic machinery, seafood processing, food and snacks, tea, and alcoholic beverages.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"What buying functions does Chaoangoods provide?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"The website provides product and manufacturer browsing, buyer registration, and quotation requests. Product listings display prices and minimum-order quantities.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"How can buyers contact Chaoangoods?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"The website lists phone and WeChat number 13714930005, email chaoangoods@gmail.com, and QQ number 2568932441. Its contact address is 5th floor, Fengxi Ceramic Building, Chao'an, Chaozhou, Guangdong, China.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Which warehouse countries are listed on Chaoangoods?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"The homepage's Ready to ship warehouse section lists the United States, Vietnam, Thailand, Indonesia, and China.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Which confectionery products appear on Chaoangoods?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Homepage listings include popping candy, lollipops, mint candy, lozenges, and preserved-fruit snacks.\"\n          }\n        }\n      ]\n    }\n  ]\n}\n        ","type":"application\u002Fld+json","body":true}],"style":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_axios_9d6fa4e8 === 'function') {
    await nuxt_plugin_axios_9d6fa4e8(app.context, inject)
  }

  if (typeof nuxt_plugin_serverstorage_461f9ce5 === 'function') {
    await nuxt_plugin_serverstorage_461f9ce5(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_d905880e === 'function') {
    await nuxt_plugin_elementui_d905880e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_errorhandler_25db1b11 === 'function') {
    await nuxt_plugin_errorhandler_25db1b11(app.context, inject)
  }

  if (typeof nuxt_plugin_globalinit_7f231a86 === 'function') {
    await nuxt_plugin_globalinit_7f231a86(app.context, inject)
  }

  if (typeof nuxt_plugin_routerpush_671c28aa === 'function') {
    await nuxt_plugin_routerpush_671c28aa(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_54ec6fe8 === 'function') {
    await nuxt_plugin_globalcomponents_54ec6fe8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazyload_0d09004e === 'function') {
    await nuxt_plugin_lazyload_0d09004e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueesign_b931fdb2 === 'function') {
    await nuxt_plugin_vueesign_b931fdb2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_socialsharing_34386970 === 'function') {
    await nuxt_plugin_socialsharing_34386970(app.context, inject)
  }

  if (typeof nuxt_plugin_eventbus_bb49754e === 'function') {
    await nuxt_plugin_eventbus_bb49754e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analytics_3ba45812 === 'function') {
    await nuxt_plugin_analytics_3ba45812(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
